import React, { useState } from "react";
import { toast } from "sonner";
import { Send, MessageCircle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

const inputCls = "mt-2 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] focus:border-[#D4AF37] rounded-sm px-4 py-2.5 w-full outline-none";
const labelCls = "text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]";

export const contactMissing = (u) => u?.role === "supplier" && !(u.kyc?.telegram || u.kyc?.whatsapp);

export default function SupplierContactGate({ children }) {
  const { user, refresh, logout } = useAuth();
  const [tg, setTg] = useState("");
  const [wa, setWa] = useState("");
  const [busy, setBusy] = useState(false);
  if (!contactMissing(user)) return children;
  const submit = async (e) => {
    e.preventDefault();
    if (!tg.trim() && !wa.trim()) { toast.error("Isi minimal salah satu: Telegram atau WhatsApp"); return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("telegram", tg); fd.append("whatsapp", wa);
    try {
      await api.put("/supplier/contact", fd);
      toast.success("Kontak tersimpan");
      await refresh();
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal menyimpan kontak"); } finally { setBusy(false); }
  };
  return (
    <div data-testid="supplier-contact-gate" className="min-h-screen bg-[#0B0B0D] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-[#202127] border border-[#D4AF37] rounded-lg p-8 space-y-5">
        <h1 className="text-2xl font-bold text-[#F5F3ED]" style={{ fontFamily: "'Playfair Display', serif" }}>Lengkapi Kontak Anda</h1>
        <p className="text-sm text-[#A8A8AD]">Supaya Admin mudah menghubungi Anda, isi minimal salah satu: username Telegram atau nomor WhatsApp.</p>
        <div>
          <label className={labelCls}><Send size={12} className="inline mr-1" />Username Telegram</label>
          <input data-testid="contact-telegram-input" placeholder="@username" value={tg} onChange={(e) => setTg(e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}><MessageCircle size={12} className="inline mr-1" />Nomor WhatsApp</label>
          <input data-testid="contact-whatsapp-input" inputMode="tel" placeholder="6281234567890" value={wa} onChange={(e) => setWa(e.target.value)} className={inputCls} />
        </div>
        <button data-testid="contact-save-btn" type="submit" disabled={busy} className="w-full bg-[#D4AF37] text-[#0B0B0D] font-bold rounded-sm py-3 hover:bg-[#F2D98D] transition-colors disabled:opacity-50">{busy ? "Menyimpan..." : "Simpan & Lanjutkan"}</button>
        <button data-testid="contact-logout-btn" type="button" onClick={logout} className="w-full text-xs text-[#A8A8AD] hover:text-[#F5F3ED] transition-colors">Keluar</button>
      </form>
    </div>
  );
}
